import { Link, useNavigate } from "react-router-dom"
import { ChevronLeft } from "lucide-react"
import { Button } from "./ui/button"

interface HeaderProps {
  showBackButton?: boolean
  backTo?: string
  showAuthButtons?: boolean
}

export default function Header({ showBackButton, backTo = "/", showAuthButtons = false }: HeaderProps) {
  const navigate = useNavigate()

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex h-14 sm:h-16 items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            {showBackButton && (
              <Button 
                variant="ghost" 
                size="icon"
                onClick={() => navigate(backTo)}
                className="mr-1 sm:mr-2 h-8 w-8 sm:h-10 sm:w-10"
              >
                <ChevronLeft className="h-4 w-4 sm:h-5 sm:w-5" />
              </Button>
            )}
            <Link to="/" className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity">
              <img 
                src="/logo.svg" 
                alt="Simples.ECG Logo" 
                className="w-6 h-6 sm:w-8 sm:h-8" 
              />
              <span className="font-semibold text-base sm:text-lg md:text-xl">Simples.ECG</span>
            </Link>

            {/* Link Simples.Health (Mobile e Desktop) */}
            <a 
              href="https://simples.health" 
              target="_blank" 
              rel="noreferrer" 
              className="flex items-center gap-1 text-[10px] sm:text-sm text-muted-foreground hover:text-primary transition-colors ml-1 sm:ml-2"
            >
              por Simples.Health
              <svg 
                className="w-2.5 h-2.5 sm:w-3 sm:h-3" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                />
              </svg>
            </a>
          </div>

          {/* Botões de Autenticação (Mobile e Desktop) */}
          {showAuthButtons && (
            <div className="flex items-center gap-2 sm:gap-3">
              <Button asChild variant="ghost" className="hidden sm:flex">
                <Link to="/login">
                  Login
                </Link>
              </Button>
              <Button asChild className="bg-[#065f46] hover:bg-[#064e3b] text-xs sm:text-base px-2 sm:px-4 h-8 sm:h-10">
                <Link to="/register">
                  Cadastre-se
                </Link>
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
} 